import { t } from '../i18n';

/**
 * Compact relative time formatter (e.g. "just now", "5m", "3h", "2d").
 * Accepts a Firestore Timestamp-like value, a Date, epoch ms, or null.
 */
export function timeAgo(value: { toMillis?: () => number } | Date | number | null | undefined): string {
    if (value == null) return '';
    let ms: number;
    if (typeof value === 'number') ms = value;
    else if (value instanceof Date) ms = value.getTime();
    else if (typeof value.toMillis === 'function') ms = value.toMillis();
    else return '';

    const diff = Date.now() - ms;
    if (!isFinite(diff)) return '';
    const sec = Math.floor(diff / 1000);
    if (sec < 45) return t('web.common.justNow');
    const min = Math.floor(sec / 60);
    if (min < 60) return t('web.common.minutesShort', { n: min });
    const hr = Math.floor(min / 60);
    if (hr < 24) return t('web.common.hoursShort', { n: hr });
    const day = Math.floor(hr / 24);
    if (day < 7) return t('web.common.daysShort', { n: day });
    const wk = Math.floor(day / 7);
    if (wk < 5) return t('web.common.weeksShort', { n: wk });
    return new Date(ms).toLocaleDateString();
}
